<template>
  <div class="home">
    <router-view ref="child" @childClick="childClick" />
    <van-tabbar v-model="tabbarActive" route>
      <van-tabbar-item icon="chat-o" :badge="num" v-if="noticeLists.length>0" replace to="/message">消息</van-tabbar-item>
      <van-tabbar-item icon="chat-o"  v-if="noticeLists.length==0" replace to="/message">消息</van-tabbar-item>
      <van-tabbar-item icon="apps-o" replace to="/work">工作台</van-tabbar-item>
      <van-tabbar-item icon="contact" replace to="/mine">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabbarActive: 1,
      noticeLists:[],
      num:0
    }
  },
  created() {
    //this.getnotic();
  },
  methods: {
    childClick(e) {
      if (e == "work") {
       // this.getnotic();
      } else {
        this.num = e;
      }
    },
    getnotic()
    {
      let that = this
      this.$ajax.post('/appapi/getNotice',{}).then(function (res) {
        if (res.code == 200) {
          that.noticeLists = res.data;
          that.num = that.noticeLists.length
        }
      })
    }
  }
}
</script>
<style lang="less">
.home{
  padding-bottom: 62px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/index.vue